import { useState } from "react";
import axios from 'axios';
import { ForgotPasswordUrl } from '../utils/network';
import { useNavigate } from 'react-router-dom';
import AuthLayout from "../components/AuthLayout";
import AuthComponent from "../components/AuthComponent";

function ForgetPassword() {
    const [loading, setLoading] = useState(false);
    const [modalState, setModalState] = useState<{
        visible: boolean;
        type: 'success' | 'error';
        message: string;
    }>({
        visible: false,
        type: 'success',
        message: ''
    });
    const history = useNavigate();

    const onSubmit = async (values: any) => {
        setLoading(true);
        try {
            const response = await axios.post(ForgotPasswordUrl, values);
            const msg = response.data?.message || "Reset password link sent successfully";
            setModalState({
                visible: true,
                type: 'success',
                message: msg
            });
        } catch (error: any) {
            const errorMsg = error.response?.data?.error || error.response?.data?.detail || error.response?.data?.message || "User with this email does not exist.";
            setModalState({
                visible: true,
                type: 'error',
                message: errorMsg
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout>
            <AuthComponent
                titleText="Reset"
                titleSpanText="Password"
                subtitleText="Enter your email address and we'll send you a link to reset your password"
                bottonText="Send Reset Link"
                isPassword={false}
                linkText="Back to Sign In"
                linkPath="/login"
                onSubmit={onSubmit}
                loading={loading}
                modalTitle="Reset Password"
                modalType={modalState.type}
                modalMsg={modalState.visible ? modalState.message : null}
                onModalClose={() => {
                    if (modalState.type === 'success') {
                        history('/login');
                    } else {
                        setModalState({ visible: false, type: 'error', message: '' });
                    }
                }}
                modalButtonText={modalState.type === 'success' ? "Login" : "Retry"}
                onModalButtonClick={() => {
                    if (modalState.type === 'success') {
                        history('/login');
                    } else {
                        setModalState({ visible: false, type: 'error', message: '' });
                    }
                }}
            />
        </AuthLayout>
    );
}

export default ForgetPassword;